import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, SourcingRequest } from "@/types";

export function useGetSourcingRequest() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["sourcing-request", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/sourcing-request`;
      const res = await guacHttpClient.get<
        SourcingRequest | null,
        HttpResponse<SourcingRequest | null>
      >(path);
      return res.data;
    },
  });
}
